<template>
<div class="analysis-articles" >
    <div class="the-latest-article gray-rollover page-1">
        <div v-for="(article, index) in featured_articles" :key="`${article.id}-${index}`" class="the-latest-content">
            <div v-if="article.image_url" class="the-latest-image image-rollover">
                <a :href="article.url">
                    <img :src="article.image_url">
                </a>
            </div>
            <div class="author-content">
                <div class="author">
                    <div class="author-name">
                        <a :href="article.url">
                            <span class="first-name" v-html="article.title"></span>
                        </a>
                        <span class="last-name"> - {{ article.author }}</span>
                    </div>
                </div>
            </div>
            <div class="the-latest-article-title gray-overlay">
                <a article.autho>
                    <p v-html="article.desc"></p>
                </a>
            </div>
        </div>
    </div>
    <div style="clear: both; height: 0px"></div>
    <div class="archive_button">
        <a href="/topic/in_the_news/fact_check_review/">More Articles →</a>
    </div>
</div>
</template>

<script>

import ApiMixin from './ApiMixin.js';

export default {
    name: "fc-articles",
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            featured_articles: [],
        };
    },
    created(){
        this.loadArticles();
    },
    methods: {
        loadArticles(){

            jsonp(this.data_sources.posts_feed+'?v='+this.cache_buster(), {name: "callback_ct_fact_check_review_posts_feed_2"}, (err, posts) => {
                if (err) {
                    console.error("error loading posts", err.message);
                } else {
                    console.log("posts", posts);

                    this.featured_articles = posts.filter((p, i) => {
                            // only want two items
                            if (i < 2) {
                                return p;
                            }
                        })
                        .map((p, i) => {

                            var author = null;

                            if (p.authors.length > 0) {
                                author = this.strip_tags(p.authors[0].fullname);
                            }

                            var image = null;

                            if (p.image !== null) {
                                image = p.image.resized_images_loc;
                            }

                            return {
                                title: p.title,
                                desc: this.strip_tags(p.body_text).substring(0, 500) + '...',
                                author: author,
                                url: p.site.url + p.permalink,
                                image_url: image,
                            };
                        });
                }
            });
        },
    },
};
</script>